import {translate} from "@prosay/i18n"
import React, {useCallback} from "react"
import {Appbar, Button} from "react-native-paper"
import {Actions} from "react-native-router-flux"
import {SearchBar} from "./SearchBar"

export interface FAQHeaderProps {
    backButton?: () => void
    faqDisabled?: boolean
    title: string
}
export const FAQHeader: React.FC<FAQHeaderProps> = ({
    backButton,
    faqDisabled = false,
    title,
}) => {
    const onPress = useCallback(() => Actions.gettingStarted(), [])

    return (
        <Appbar.Header>
            {backButton && <Appbar.BackAction onPress={backButton} />}

            <Appbar.Content {...{title}} />

            {!faqDisabled && (
                <Button color="white" onPress={onPress}>
                    {translate("ui.header.faqButton")}
                </Button>
            )}
        </Appbar.Header>
    )
}

export interface FAQHeaderWithSearchProps extends FAQHeaderProps {
    placeholder?: string
    useStateHook: () => [string, (value: string) => void]
}
export const FAQHeaderWithSearch: React.FC<FAQHeaderWithSearchProps> = ({
    children,
    placeholder,
    useStateHook,
    ...props
}) => {
    const [search, setSearch] = useStateHook()

    return (
        <>
            <FAQHeader {...props} />
            <SearchBar
                {...{
                    placeholder,
                    search,
                    setSearch,
                }}
            />
            {children}
        </>
    )
}
